<e360-header (appClick)="navigate($event)"></e360-header>
<div id="e360-home-root" class="d-flex flex-row" [ngClass]="headerService.withHeader() ? 'with-header' : 'h-100'">
  <e360-left-nav (signOut)="logout($event)" (appClick)="navigate($event)"></e360-left-nav>
  <div class="flex-grow-1">
    <eh-spinner></eh-spinner>
    <router-outlet></router-outlet>
  </div>
</div>
